// extracted by mini-css-extract-plugin
module.exports = {"eventNameTooltip":"Name_eventNameTooltip__1Vtk_","nameContainer":"Name_nameContainer__3mqjF","name":"Name_name__3Q9Z4"};